module.exports = __webpack_public_path__ + "img/samples-box.23b181c4.jpg";